import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'square-root', 'SquareRoot', [["path",{"d":"M3 12h2l4 8l4 -16h8"}]]);